import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Flag, X } from "lucide-react";

const REASONS = [
    "Not feet / off-topic",
    "NSFW / explicit",
    "Not their own photo",
    "Harassment or hate",
    "Spam or promotion",
    "Other",
];

export default function ReportDialog({ postId, onClose }) {
    const [reason, setReason] = useState(REASONS[0]);
    const [detail, setDetail] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async () => {
        const finalReason = reason === "Other" ? (detail.trim() || "Other") : `${reason}${detail.trim() ? ` — ${detail.trim()}` : ""}`;
        if (finalReason.length < 3) { toast.error("Please describe the issue"); return; }
        setBusy(true);
        try {
            await api.post(`/posts/${postId}/report`, { reason: finalReason });
            toast.success("Reported. Thanks for keeping footsie tasteful.");
            onClose();
        } catch (e) {
            toast.error(formatApiError(e));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-[#0A0A0A]/40 z-50 flex items-center justify-center p-4" onClick={onClose} data-testid="report-dialog-overlay">
            <div className="bg-white brut-lg rounded-xl p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()} data-testid="report-dialog">
                <div className="flex items-start justify-between mb-4">
                    <div>
                        <h2 className="display text-2xl font-black flex items-center gap-2"><Flag className="w-5 h-5" /> Report post</h2>
                        <p className="text-sm text-[#4A4A4A] font-medium">Tell us what's wrong. Reports are anonymous.</p>
                    </div>
                    <button onClick={onClose} className="p-1" aria-label="Close" data-testid="report-close"><X className="w-5 h-5" /></button>
                </div>
                <div className="space-y-2 mb-3">
                    {REASONS.map((r) => (
                        <label key={r} className="flex items-center gap-2 cursor-pointer text-sm font-medium" data-testid={`reason-${r}`}>
                            <input
                                type="radio"
                                name="reason"
                                value={r}
                                checked={reason === r}
                                onChange={() => setReason(r)}
                                className="w-4 h-4 border-2 border-[#0A0A0A]"
                            />
                            {r}
                        </label>
                    ))}
                </div>
                <textarea
                    value={detail}
                    onChange={(e) => setDetail(e.target.value)}
                    maxLength={400}
                    rows={2}
                    placeholder="Add detail (optional)"
                    className="w-full px-3 py-2 rounded-lg brut-inset bg-white font-medium focus:outline-none text-sm"
                    data-testid="report-detail"
                />
                <button
                    onClick={submit}
                    disabled={busy}
                    className="mt-4 w-full px-4 py-3 rounded-lg brut bg-[#FF5A5F] text-white font-bold disabled:opacity-50"
                    data-testid="report-submit"
                >
                    {busy ? "Submitting…" : "Submit report"}
                </button>
            </div>
        </div>
    );
}
